/* cheeky.js — behaviours for the Cheekynook landing (countdowns, gallery, bundles, cart, sticky bar, feed) */
(function () {
  if (window.__ckInit) return; window.__ckInit = true;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Countdowns: any [data-ck-deadline] containing [data-d],[data-h],[data-m],[data-s] */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    $$('[data-ck-deadline]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-ck-deadline'));
      if (isNaN(end)) return;
      var t = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), s = t % 60;
      var map = { d: d, h: pad(h), m: pad(m), s: pad(s) };
      Object.keys(map).forEach(function (k) { var n = el.querySelector('[data-' + k + ']'); if (n) n.textContent = map[k]; });
      if (t === 0) { var c = el.closest('[data-ck-hide-ended]'); if (c) c.style.display = 'none'; }
    });
  }
  tick(); setInterval(tick, 1000);

  /* Gallery: scroll the images physically; keep thumbnail state in sync with touch. */
  $$('[data-ck-gallery]').forEach(function (g) {
    var track = g.querySelector('.ck-gal__track');
    if (!track) return;
    var imgs = $$('img', track), thumbs = $$('.ck-gal__thumbs button', g), i = 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function mark(n) {
      i = Math.max(0, Math.min(n, imgs.length - 1));
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function show(n) {
      if (!imgs.length) return;
      var next = (n + imgs.length) % imgs.length;
      imgs[next].loading = 'eager';
      mark(next);
      track.scrollTo({ left: next * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth' });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = g.querySelector('.ck-gal__arrow--prev'), next = g.querySelector('.ck-gal__arrow--next');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    var frame;
    track.addEventListener('scroll', function () {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
    }, {passive:true});
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); show(i + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    if (window.ResizeObserver) new ResizeObserver(function () {
      track.scrollTo({left: i * track.clientWidth, behavior:'instant'});
    }).observe(track);
    mark(0);
  });

  /* Buy box: tiers, gifts, add to cart, sticky bar */
  $$('[data-ck-buy]').forEach(function (box) {
    var tiers = $$('.ck-tier', box), btn = box.querySelector('[data-ck-atc]'), err = box.querySelector('.ck-err');
    var sticky = document.querySelector('[data-ck-sticky]');
    var stickyBtn = sticky && sticky.querySelector('button'), stickyName = sticky && sticky.querySelector('[data-ck-sticky-name]');
    var label = btn ? btn.getAttribute('data-label') : 'Add to cart';
    function current() { var on = box.querySelector('.ck-tier input:checked'); return on ? on.closest('.ck-tier') : tiers[0]; }
    var userBagChoice = false, giftsReady = false;
    var money = function (value) {return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:box.dataset.currency || 'USD'}).format(value / 100);};
    function sync() {
      var t = current(); if (!t) return;
      tiers.forEach(function (x) { x.classList.toggle('is-on', x === t); });
      var q = parseInt(t.getAttribute('data-qty'), 10) || 1, cents = Number(t.getAttribute('data-total-cents'));
      $$('[data-ck-addon]',box).forEach(function (addon) {
        var row = addon.closest('.ck-addon');
        if (addon.dataset.kind === 'bag') {
          var included = q >= 3;
          addon.checked = included || userBagChoice;
          addon.disabled = included;
          row.classList.toggle('is-included',included);
          row.querySelector('[data-addon-price]').textContent = included ? 'FREE with your bundle' : money(Number(addon.dataset.price));
        } else {row.querySelector('[data-addon-price]').textContent = money(Number(addon.dataset.price));}
        if (addon.checked && !addon.disabled) cents += Number(addon.dataset.price);
      });
      var total = Number.isFinite(cents) ? money(cents) : t.getAttribute('data-total');
      if (btn) btn.textContent = label + ' — ' + total;
      if (stickyBtn) stickyBtn.textContent = label + ' — ' + total;
      if (stickyName) stickyName.textContent = t.getAttribute('data-name');
      $$('.ck-gift', box).forEach(function (gf) {
        var need = parseInt(gf.getAttribute('data-unlock'), 10) || 1, on = q >= need;
        var wasOn = gf.classList.contains('is-on');
        gf.classList.toggle('is-on', on);
        if (!on) {
          clearTimeout(gf.ckGiftTimer);
          gf.classList.remove('is-opening');
        } else if (giftsReady && !wasOn) {
          gf.classList.add('is-opening');
          gf.ckGiftTimer = setTimeout(function () { gf.classList.remove('is-opening'); }, 950);
        }
        var c = gf.querySelector('.ck-gift__chk'); if (c) c.textContent = on ? '✓' : '🔒';
      });
      giftsReady = true;
    }
    tiers.forEach(function (t) { var r = t.querySelector('input'); if (r) r.addEventListener('change', sync); });
    $$('[data-ck-addon]',box).forEach(function (addon) {addon.addEventListener('change',function () {if (addon.dataset.kind === 'bag') userBagChoice = addon.checked;sync();});});
    sync();

    function add() {
      var t = current(), id = t.getAttribute('data-tier-variant') || box.getAttribute('data-variant');
      if (!id) { if (err) { err.textContent = 'This product is not available on the Online Store yet.'; err.style.display = 'block'; } return; }
      var items = [{ id: Number(id), quantity: parseInt(t.getAttribute('data-cart-quantity'), 10) || 1 }];
      $$('[data-ck-addon]:checked',box).forEach(function (addon) {
        if (!addon.disabled && addon.value) items.push({id:Number(addon.value),quantity:1,properties:{_ck_addon:addon.dataset.kind}});
      });
      [btn, stickyBtn].forEach(function (b) { if (b) { b.disabled = true; b.textContent = 'Adding…'; } });
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); }); return r.json(); })
        .then(function () {window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
        .catch(function (e) {
          if (err) { err.textContent = e.message; err.style.display = 'block'; }
          [btn, stickyBtn].forEach(function (b) { if (b) b.disabled = false; }); sync();
        });
    }
    if (btn) btn.addEventListener('click', add);
    if (stickyBtn) stickyBtn.addEventListener('click', add);
    var change = sticky && sticky.querySelector('[data-ck-change]');
    if (change) change.addEventListener('click', function (e) { e.preventDefault(); box.scrollIntoView({ behavior: 'smooth', block: 'start' }); });

    if (sticky && btn) {
      var ticking = false;
      function upd() { ticking = false; var r = btn.getBoundingClientRect(); sticky.classList.toggle('is-on', r.bottom < 0); }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd); upd();
    }
  });

  /* Feed carousel arrows */
  $$('[data-ck-feed]').forEach(function (f) {
    var tr = f.querySelector('.ck-feed__track'), p = f.querySelector('.ck-feed__prev'), n = f.querySelector('.ck-feed__next');
    function step(dir) { var c = tr.querySelector('.ck-feed__card'); tr.scrollBy({ left: dir * ((c ? c.offsetWidth : 260) + 16), behavior: 'smooth' }); }
    function upd() { if (p) p.disabled = tr.scrollLeft < 4; if (n) n.disabled = tr.scrollLeft + tr.clientWidth > tr.scrollWidth - 4; }
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
    tr.addEventListener('scroll', upd, { passive: true }); upd();
  });

  /* Showcase video: load only when visible */
  $$('video[data-ck-lazy]').forEach(function (v) {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { $$('source[data-src]', v).forEach(function (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); }); v.load(); v.play().catch(function () {}); io.disconnect(); }
      });
    }, { rootMargin: '200px' });
    io.observe(v);
  });
})();


